import React from 'react';

import LetsFishingImage from './assets/letsFishing.svg';
import { DisplayTemplate } from './display-results-template';

export const LuckyNoFilteredTemplate = () => {
  return (
    <DisplayTemplate
      image={LetsFishingImage}
      title="Lucky You! All fishes are available! Catch them"
      subtitle={'Please click the available tab to keep fishing'}
    />
  );
};